import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
import { cn } from '../../utils/cn';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Handle Escape key to close
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-182">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-stone-950/80 backdrop-blur-sm transition-opacity animate-in fade-in duration-200" onClick={onClose} aria-hidden="true" data-id="element-183" />

      {/* Modal Content */}
      <div className="relative w-full max-w-3xl max-h-[90vh] flex flex-col bg-white rounded-2xl shadow-2xl animate-in fade-in zoom-in-95 duration-200" data-id="element-184">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-stone-100" data-id="element-185">
          <h2 id="modal-title" className="text-xl font-serif font-bold text-stone-900" data-id="element-186">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 text-stone-400 hover:text-stone-600 hover:bg-stone-100 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500" aria-label="Cerrar modal" data-id="element-187">
            <XIcon className="w-5 h-5" data-id="element-188" />
          </button>
        </div>

        {/* Scrollable Body */}
        <div className="flex-1 overflow-y-auto p-6 text-stone-600 space-y-6" data-id="element-189">
          {children}
        </div>
      </div>
    </div>;
}